import { MouseEvent } from "react";

import { IconButton, Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";

import { TLocalCourseDocument } from "../../hooks/useMyCourseInstructor";

export type TCourseDocumentImageProps = {
	file: TLocalCourseDocument;
	onRemoveFile: (id: string) => void;
};

export function LocalCourseDocumentImage({
	file,
	onRemoveFile,
}: TCourseDocumentImageProps) {
	const onClickRemoveFile = (
		e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
	) => {
		e.stopPropagation();
		if (file.id) {
			onRemoveFile(file.id);
		}
	};

	return (
		<div className="media-container">
			<img
				src={file.data}
				alt={file.type}
				className="media"
				draggable={false}
			/>
			<Tooltip title="Remove">
				<IconButton className="remove-button" onClick={onClickRemoveFile}>
					<IoClose />
				</IconButton>
			</Tooltip>
		</div>
	);
}
